module.exports = __webpack_public_path__ + "img/shoppyli.jpg_w545.a340c59e.jpg";